import { Controller } from '@hotwired/stimulus';

/**
 * Base Stimulus controller that provides an AbortSignal tied to the
 * controller's lifecycle. It creates an AbortController on connect and
 * aborts it on disconnect.
 *
 * Subclass this and implement `connectWithSignal(signal)` and
 * `disconnectWithSignal()`. Do not override `disconnect()`; it will throw if
 * overridden.
 */
export default class ControllerWithSignal extends Controller {
  #disconnectAbortController;
  disconnectSignal;

  connectWithSignal(/* signal */) {
    // Implement in subclasses
  }

  disconnectWithSignal() {
    // Implement in subclasses
  }

  connect() {
    this.#disconnectAbortController = new AbortController();
    this.disconnectSignal = this.#disconnectAbortController.signal;
    this.connectWithSignal(this.#disconnectAbortController.signal);

    if (this.disconnect !== ControllerWithSignal.prototype.disconnect) {
      throw new Error(
        'ControllerWithSignal: disconnect method must not be overridden. Use disconnectWithSignal instead.',
      );
    }
  }

  disconnect() {
    this.#disconnectAbortController.abort();
    this.disconnectWithSignal();
  }
}
